<template>
  <template v-for="chart in charts" :key="chart.title[locale] + chart.name">
    <CardChart
      :title="chart.title[locale]"
      :info="chart.info?.[locale]"
      :chart="chart.props"
      :dashboardFullscreen="fullscreen"
      :enable-fullscreen="true"
    />
  </template>
</template>

<script lang="ts" setup>
import { LocaleString } from '@/api-client/models/utilization/Contracts'
import CardChart from './CardChart.vue'
import { Chart as ChartDefinition } from './ChartComponent'
import { useI18n } from 'vue-i18n'
import { computed, inject } from 'vue'
import { sharedDataKey } from '../../types'

export type Chart = {
  name: string
  title: LocaleString
  info?: LocaleString
  props: ChartDefinition
}

type Props = {
  charts: Chart[]
}

defineProps<Props>()

const { locale } = useI18n()

const sharedData = inject(sharedDataKey)

const fullscreen = computed(() => sharedData?.fullscreen ?? false)
</script>
